import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  MATERIAL_REQUEST_REFRESH: createSagaAction('MATERIAL_REQUEST_REFRESH'),

  CREATE_MATERIAL_REQUEST: createSagaAction('CREATE_MATERIAL_REQUEST'),
  UPDATE_MATERIAL_REQUEST: createSagaAction('UPDATE_MATERIAL_REQUEST'),
  DELETE_MATERIAL_REQUEST: createSagaAction('DELETE_MATERIAL_REQUEST'),

  GET_MATERIAL_ITEMS: createSagaAction('GET_MATERIAL_ITEMS'),

  UPLOAD_MATERIAL_REQUESTS_ATTACHMENT: createSagaAction('UPLOAD_MATERIAL_REQUESTS_ATTACHMENT'),
  GET_MATERIAL_REQUESTS_ATTACHMENTS: createSagaAction('GET_MATERIAL_REQUESTS_ATTACHMENTS'),
  UPDATE_MATERIAL_REQUESTS_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_MATERIAL_REQUESTS_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_MATERIAL_REQUESTS_ATTACHMENT: createSagaAction('DELETE_MATERIAL_REQUESTS_ATTACHMENT')
}

// Action Creators
export const actions = {
  materialRequestRefresh: ({ jobId, next }) => ({
    type: constants.MATERIAL_REQUEST_REFRESH.ACTION,
    jobId,
    next
  }),

  createMaterialRequest: ({ jobId, content, requestItems, userId }) => ({
    type: constants.CREATE_MATERIAL_REQUEST.ACTION,
    jobId,
    content,
    requestItems,
    userId
  }),

  updateMaterialRequest: ({ jobId, materialRequestId, userId, content, requestItems }) => ({
    type: constants.UPDATE_MATERIAL_REQUEST.ACTION,
    jobId,
    materialRequestId,
    userId,
    content,
    requestItems
  }),

  deleteMaterialRequest: ({ materialRequestId, jobId }) => ({
    type: constants.DELETE_MATERIAL_REQUEST.ACTION,
    jobId,
    materialRequestId
  }),

  getMaterialItems: ({ materialRequestId }) => ({
    type: constants.GET_MATERIAL_ITEMS.ACTION,
    materialRequestId
  }),

  // Attachment actions
  uploadAttachment: ({ formData, materialRequestId }) => ({
    type: constants.UPLOAD_MATERIAL_REQUESTS_ATTACHMENT.ACTION,
    formData,
    materialRequestId
  }),

  getAttachments: ({ materialRequestId }) => ({
    type: constants.GET_MATERIAL_REQUESTS_ATTACHMENTS.ACTION,
    materialRequestId
  }),

  updateAttachmentDescription: ({ attachmentId, materialRequestId, description, userId }) => ({
    type: constants.UPDATE_MATERIAL_REQUESTS_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    materialRequestId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, materialRequestId }) => ({
    type: constants.DELETE_MATERIAL_REQUESTS_ATTACHMENT.ACTION,
    attachmentId,
    materialRequestId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.MATERIAL_REQUEST_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.MATERIAL_REQUEST_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteMaterialRequests: action.payload
      }
    case constants.MATERIAL_REQUEST_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.CREATE_MATERIAL_REQUEST.SUCCESS:
      return {
        ...state
      }
    case constants.UPDATE_MATERIAL_REQUEST.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_MATERIAL_REQUEST.SUCCESS:
      return {
        ...state
      }
    case constants.GET_MATERIAL_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_MATERIAL_ITEMS.SUCCESS:
      return {
        ...state,
        materialItems: action.payload
      }

    case constants.UPLOAD_MATERIAL_REQUESTS_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_MATERIAL_REQUESTS_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_MATERIAL_REQUESTS_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_MATERIAL_REQUESTS_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobMaterialRequestsAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_MATERIAL_REQUESTS_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_MATERIAL_REQUESTS_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_MATERIAL_REQUESTS_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteMaterialRequestActions.js